import { render, staticRenderFns } from "./RegisterAddress.vue?vue&type=template&id=2863ef53&"
import script from "./RegisterAddress.vue?vue&type=script&lang=ts&"
export * from "./RegisterAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports